import { Input as MantineInput } from '@mantine/core';
import { FC } from 'react';

export type MantineInputErrorProps = React.ComponentProps<typeof MantineInput.Error>;

export const InputError: FC<MantineInputErrorProps> = props => {
    return <MantineInput.Error {...props} />;
};
